import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {
    // 获取纪念馆时空信箱列表
    GetMailBoxMailBoxSearchList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MailBox/MailBoxSearch',payload, res => {
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 获取时空信箱列表
    getMailBoxList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MailBoxManage/GetMailBoxList',payload, res => {
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 添加时空信箱评论 
    getMailBoxAddReply({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MailBox/MailBoxAddReply',payload, res => {
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 添加时空信箱留言 
    MailBoxAddVue({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MailBox/MailBoxAddVue',payload, res => {
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 时空信箱点赞 
    getMailBoxAddPraise({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MailBox/MailBoxAddPraise',payload, res => {
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 删除时空信箱
    getMailBoxMailBoxDelVue({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MailBox/MailBoxDelVue',payload, res => {
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
